import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FormaPago } from '@p-p-portafolio/interfaces/formaPago';
import { FormaPagoService } from '@p-p-portafolio/services/formaPago.service';

@Component({
  selector: 'app-formaPago-form',
  templateUrl: './formaPago-form.component.html',
  providers: [MessageService]
})
export class FormaPagoFormComponent implements OnInit, OnChanges {
  @Input() model: FormaPago | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private formaPagoService: FormaPagoService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.loadFormaPago();
      } else {
        this.initForm();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      clave: [{ value: '', disabled: !!this.model }, [Validators.required]],
      descripcion: ['', [Validators.required]],
      tope: ['0'],
      pedir_Referencia: [0, [Validators.required]],
      efectivo: [0, [Validators.required]],
      pedir_Autorizacion: [0, [Validators.required]]
    });
  }

  loadFormaPago(): void {
    if (!this.model) return;
    
    this.form.patchValue({
      clave: this.model.clave,
      descripcion: this.model.descripcion,
      tope: this.model.tope || '0',
      pedir_Referencia: this.model.pedir_Referencia,
      efectivo: this.model.efectivo,
      pedir_Autorizacion: this.model.pedir_Autorizacion
    });
    this.form.get('clave')?.disable();
  }

  create(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 1,
      tope: '',
      clave: formData.clave,
      descripcion: formData.descripcion,
      pedir_Referencia: formData.pedir_Referencia ? 1 : 0,
      iEfectivo: formData.efectivo ? 1 : 0,
      pedir_Autorizacion: formData.pedir_Autorizacion ? 1 : 0
    };

    this.formaPagoService.saveFormaPago(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Forma de pago creada correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.errors?.[0] || 'Error al crear la forma de pago'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear la forma de pago'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 2,
      tope: '',
      clave: formData.clave,
      descripcion: formData.descripcion,
      pedir_Referencia: formData.pedir_Referencia ? 1 : 0,
      iEfectivo: formData.efectivo ? 1 : 0,
      pedir_Autorizacion: formData.pedir_Autorizacion ? 1 : 0
    };

    this.formaPagoService.updateFormaPago(payload).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({
            success: true,
            message: 'Forma de pago actualizada correctamente'
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.errors?.[0] || 'Error al actualizar la forma de pago'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar la forma de pago'
        });
        this.loading = false;
      }
    });
  }
} 